// sanity.js
import { createClient } from '@sanity/client';

export const client = createClient({
  projectId: process.env.REACT_APP_SANITY_PROJECT_ID,       // from .env or Vercel
  dataset: process.env.REACT_APP_SANITY_DATASET,            // from .env or Vercel
  apiVersion: process.env.REACT_APP_SANITY_API_VERSION,     // from .env or Vercel
  useCdn: process.env.REACT_APP_SANITY_USE_CDN === 'true',  // convert string to boolean
  // token: process.env.REACT_APP_SANITY_SECRET_TOKEN      // only if updating content
});
